import React, { useEffect } from 'react';
import { sendTrackingInfo, ModalInformation } from '@panel/commons';
import { useTranslation } from 'react-i18next';

function FreemiumFlowOffToOnCreditsNoFreeNo(props) {
  const { onClickAction, onClickCancel, postingId, isInmobiliaria } = props;
  const { t } = useTranslation();

  useEffect(() => {
    const txt = `Republicar Aviso_${isInmobiliaria ? 'Inmobiliaria' : 'Particular'}-Intencion`;
    sendTrackingInfo('Mis avisos', txt);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleClickAction = e => {
    const txt = `Republicar Aviso Sin credito_Adquirir Credito_${isInmobiliaria ? 'Inmobiliaria' : 'Particular'}`;
    sendTrackingInfo('Mis avisos', txt);
    onClickAction(e);
  };

  const handleCancel = () => {
    const txt = `Republicar Aviso Sin credito_Cancelar_${isInmobiliaria ? 'Inmobiliaria' : 'Particular'}`;
    sendTrackingInfo('Mis avisos', txt);
    onClickCancel();
  };

  return (
    <ModalInformation
      onClickAction={e => handleClickAction(e)}
      onClickCancel={handleCancel}
      onClickOutside={handleCancel}
      title={t('panel.modal.FreemiumFlowOffToOnCreditsNoFreeNo.title')}
      message={t('panel.modal.FreemiumFlowOffToOnCreditsNoFreeNo.text')}
      ctaCancel={t('panel.modal.cta.cancel')}
      urlLink={`..${t('panel.url.ecommerce.particular')}?idPosting=${postingId}`}
      ctaAnchor={t('panel.modal.cta.buyCredits')}
    />
  );
}

export { FreemiumFlowOffToOnCreditsNoFreeNo };
